import { useState } from 'react';
import { StoryItem } from '../../i18n/types';
import { BrandHighlight } from '../BrandHighlight';

interface FullStoryItem extends StoryItem {
  img: string;
}

interface Props {
  story: FullStoryItem[];
}

export default function WalkthroughTab({ story }: Props) {
  const [index, setIndex] = useState(0);

  const goTo = (i: number) => setIndex(i);

  return (
    <div>
      {/* Desktop Carousel */}
      <div className="d-none d-md-block">
        <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
          {story.map((s, i) => (
            <button
              key={s.num}
              onClick={() => goTo(i)}
              className={`carousel-nav-button ${i === index ? 'carousel-nav-button-active' : 'carousel-nav-button-inactive'}`}
            >
              {s.num}
            </button>
          ))}
        </div>
        <div className="carousel-content-wrapper">
          <h3 className="text-white fw-bold mb-3 carousel-heading">
            {story[index].label}
          </h3>
          <p className="carousel-description">
            <BrandHighlight text={story[index].desc} />
          </p>
          <img
            src={story[index].img}
            alt={story[index].alt}
            className="image-card-rounded"
          />
        </div>
      </div>

      {/* Mobile Sequential List */}
      <div className="d-block d-md-none d-flex flex-column gap-4">
        {story.map((s) => (
          <div key={s.num} className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-2">
              <span className="mobile-step-badge">
                {s.num}
              </span>
              <h3 className="text-white fw-semibold mb-0 mobile-step-heading">
                {s.label}
              </h3>
            </div>
            <p className="mobile-step-description">
              <BrandHighlight text={s.desc} />
            </p>
            <img src={s.img} alt={s.alt} className="mobile-step-image" />
          </div>
        ))}
      </div>
    </div>
  );
}
